import { Logo } from "@/components/Logo";
import { WhatsAppButton } from "@/components/WhatsAppButton";

export const Navbar = () => (
  <header
    data-testid="site-navbar"
    className="sticky top-0 z-40 bg-white/85 backdrop-blur-xl border-b border-navy/5"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 sm:h-[72px] flex items-center justify-between">
      <Logo />
      <WhatsAppButton
        location="navbar"
        testId="navbar-whatsapp-button"
        size="sm"
        className="sm:!px-6 sm:!py-3"
      >
        Hubungi Kami
      </WhatsAppButton>
    </div>
  </header>
);
